export class NoteType {
  static feed = "feed";
  static location = "location";
  static training = "training";
  static weight = "weight";
  static other = "other";
  static sign = "sign";
  static attendingVetForm = "attendingVetForm";
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/types/note-type.ts